const $_default =
{
    modelValue()
    {
        return { from: 0, to: 100 };
    },

    format( value )
    {
        return value;
    },

    reduce( value )
    {
        return value;
    }
}

export default
{
    props:
    {
        modelValue : { type: Object, default: $_default.modelValue },
        class      : { type: String, default: '' },
        min        : { type: Number, default: 0 },
        max        : { type: Number, default: 100 },
        step       : { type: Number, default: 1 },
        format     : { type: Function, default: $_default.format },
        reduce     : { type: Function, default: $_default.format },
        disabled   : { type: Boolean, default: false },
        showInputs : { type: Boolean, default: true },
        showLabels : { type: Boolean, default: true },
        mode       : { type: String, default: 'range', validator: value => ['range', 'input'].includes( value ) },
    }
}